<template>
  <AppButton
    class="class-join-button"
    type="button"
    :label="label"
    :variant="variant"
    :block="block"
    :loading="loading"
    :disabled="disabled"
    v-bind="$attrs"
    @click="handleClick"
  />
  <ErrorModal
    v-if="showErrorModal"
    :visible="errorModalVisible"
    :messages="errorModalMessages"
    :fallback-message="resolvedFallbackMessage"
    :title="resolvedErrorTitle"
    :cta-label="resolvedErrorCtaLabel"
    @close="closeErrorModal"
  />
</template>

<script>
import classJoinButtonConfig from './ClassJoinButton.logic';

export default classJoinButtonConfig;
</script>


<style scoped>
.class-join-button {
  width: auto;
}
</style>
